package com.trevorwiebe.timesheet.admin.customer.presentation

import com.trevorwiebe.timesheet.core.domain.model.Customer

sealed class CustomersEvent {
    data object OnAddCustomerClick : CustomersEvent()
    data class OnEditCustomerClick(val customer: Customer) : CustomersEvent()
    data object OnDismissDialog : CustomersEvent()
    data class OnSaveCustomer(
        val contactName: String,
        val companyName: String,
        val address: String,
        val phone: String,
        val emails: List<String>,
        val paymentTerms: String,
        val notes: String
    ) : CustomersEvent()
    data object OnDeleteCustomer : CustomersEvent()
    data object OnRestoreCustomer : CustomersEvent()
    data class OnFilterToggled(val filter: CustomerFilter) : CustomersEvent()
    data object OnErrorShown : CustomersEvent()
}
